import React from "react";
import styled from "styled-components";
import { MESH_IMG } from "../../config/constants";

const SavaariBanner = ({data, isLanding = false, isReview = false }) => {
  if(!data?.show_savaari_banner_dweb) return null;
  return (
    <Card isReview={isReview}>
      {!isLanding ? <LeftPattern className="flip-horizontal">
        <img src={MESH_IMG} alt="savaari_logo" height="56" width="176" />
      </LeftPattern> : null}
      <ContentContainer>
        <TextContent>
          <Title>{data?.title}</Title>
          <Subtitle>{data?.sub_title}</Subtitle>
        </TextContent>
        <ImageContainer>
          <SavaariLogoDweb
            src={data?.dweb_logo_url}
            alt="savaari_logo"
            height="28"
            width="165"
          />
        </ImageContainer>
      </ContentContainer>
      {!isLanding ? <RightPattern>
        <img src={MESH_IMG} alt="savaari_logo" height="56" width="176" />
      </RightPattern> : null}
    </Card>
  );
};

export default SavaariBanner;

const Card = styled.div<{ isReview: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: calc(1200px + 32px);
  width: 100%;
  background-color: #e6f7ff;
  border-radius: ${(props) => (props.isReview ? '4px' : '8px')};
  overflow: hidden;
  margin: 10px 0;
  border: 0.01px solid #e6f7ff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
`;

const LeftPattern = styled.div`
  display: block;
  transform: scaleX(-1);
`;

const RightPattern = styled.div`
  display: block;
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 20px;
  padding: 16px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #757575;
  margin: 0;
`;

const ImageContainer = styled.div`
  max-width: 35%;
  text-align: right;
`;

const SavaariLogoDweb = styled.img`
  display: block;
`;
